/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Suggest_PlaceholderInputs */

const en_us2_community_suggest_placeholder = /** @type {(inputs: Community_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E.g. training at home on weekends`)
};

const pt_br2_community_suggest_placeholder = /** @type {(inputs: Community_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: poder treinar em casa nos fins de semana`)
};

const es_419_community_suggest_placeholder = /** @type {(inputs: Community_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ej.: entrenar en casa los fines de semana`)
};

const pt_pt2_community_suggest_placeholder = /** @type {(inputs: Community_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: poder treinar em casa aos fins de semana`)
};

const fr_fr2_community_suggest_placeholder = /** @type {(inputs: Community_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex. : m'entraîner à la maison le week-end`)
};

const de_de2_community_suggest_placeholder = /** @type {(inputs: Community_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z. B. am Wochenende zu Hause trainieren`)
};

const it_it2_community_suggest_placeholder = /** @type {(inputs: Community_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es.: allenarmi a casa nel fine settimana`)
};

/**
* | output |
* | --- |
* | "E.g. training at home on weekends" |
*
* @param {Community_Suggest_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_suggest_placeholder = /** @type {((inputs?: Community_Suggest_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Suggest_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_suggest_placeholder(inputs)
	if (locale === "es-419") return es_419_community_suggest_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_community_suggest_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_community_suggest_placeholder(inputs)
	if (locale === "de-DE") return de_de2_community_suggest_placeholder(inputs)
	if (locale === "it-IT") return it_it2_community_suggest_placeholder(inputs)
	return en_us2_community_suggest_placeholder(inputs)
});
export { community_suggest_placeholder as "community.suggest_placeholder" }